interface CountByParams<Type, KeyName extends PropertyKey> {
  items: Array<Type>;
  iteratee: ((item: Type) => KeyName) | keyof Type;
}

/**
 * Counts the number of occurrences of each unique value in the array.
 * @param iteratee - The function to extract the key from each item or the key to use.
 * @param items - The array of items to count.
 * @returns An object with the keys and the number of occurrences.
 */
export function countBy<Type, K extends PropertyKey>({
  iteratee,
  items,
}: CountByParams<Type, K>): Record<PropertyKey, number> {
  return items.reduce((counts, item) => {
    const key = (
      typeof iteratee === 'function' ? iteratee(item) : item[iteratee]
    ) as PropertyKey;
    counts[key] = (counts[key] ?? 0) + 1;
    return counts;
  }, {} as Record<PropertyKey, number>);
}
